import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import I18n from "i18n-js";
import _ from "lodash";

import api from "../api";

import { SUPPORTED_EXTENSIONS } from "../config/resume";

import FileChooser from "../commons/FileChooser";

import BaseModal from "./BaseModal";

const SetResumeModal = ({ user, onClose }) => {

  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [resume, setResume] = useState(null);

  useEffect(() => {
    notifyModalViewed();
  }, []);

  const notifyModalViewed = () => {
    api.put(`/users/${user?.uuid}`, { user: { resume_upload_notified: true }})
      .catch(err => {
        if (err.response && err.response.data && err.response.data.message) {
          toast.error(<b>{err.response.data.message}</b>);
        } else {
          toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
        }
        setLoading(false);
        console.error(err);
      });
  }

  const uploadResume = () => {
    if (!resume) return;
    
    setLoading(true);

    const data = new FormData();
    data.append("resume", resume);

    api.post("/users/resume", data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(_ => {
      setOpen(false);
      toast.success(<b>{I18n.t("common.saved_successfully")}</b>);
    })
    .catch(err => {
      if (err.response && err.response.data && err.response.data.message) {
        toast.error(<b>{err.response.data.message}</b>);
      } else {
        toast.error(<b>{I18n.t("common.errors.unexpected_error")}</b>);
      }
      setLoading(false);
      console.error(err);
    });
  }

  const renderBody = () => (
    <FileChooser
      disabled={loading}
      supportedFiles={SUPPORTED_EXTENSIONS}
      onFileSelected={setResume}
    />
  );

  return (
    <BaseModal
      open={open}
      name="set-resume"
      title={I18n.t("modal.set_resume_modal.title")}
      introduction={I18n.t("modal.set_resume_modal.introduction")}
      body={renderBody()}
      confirm={{
        show: true,
        disabled: _.isNull(resume),
        title: I18n.t("common.confirm"),
        loading: loading
      }}
      cancel={{
        show: true,
        title: I18n.t("common.skip")
      }}
      onConfirm={uploadResume}
      onClose={() => setOpen(false)}
      onCloseAnimationEnd={onClose}
    />
  );
}

export default SetResumeModal;
